import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const DEVICE_API = "/trackDevice";

// ----------------------- STATE ------------------------- //
const state = {
  device_data: [],
  currentIndex: -1
};

// ----------------------- GETTERS ----------------------- //
const getters = {
  getDevice: state => getField(state.device_data[state.currentIndex]),

  getCurrentDevice: state => {
    return state.device_data[state.currentIndex];
  },

  getActiveDevices: state => {
    return state.device_data.filter(element => element.active==true)
  },

    getActiveTrackerEnabledDevices: state => {
        return state.device_data.filter(element => element.active && element.tracker)
    },
    getDeviceById: state => id => {
    return state.device_data.find(device => device.id === id)
    },

    getDeviceByVehicleId: state => vehicleId => {
        return state.device_data.find(device => device.vehicle_id === vehicleId);
    },
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
  updateDevice(state, payload) {
    updateField(state.device_data[state.currentIndex], payload);
  },

  setCurrentIndexByID(state, theID) {
    state.currentIndex = state.device_data.findIndex(
      device => device.id == theID
    );
  },

  setCurrentIndexByVehicleID(state,vehicleID){
    state.currentIndex = state.device_data.findIndex(
        device => device.vehicle_id == vehicleID
    );
  },

  loadAllDevices(state, payload) {
    state.device_data = payload.data;
    state.currentIndex = 0;
  },

  addDevice(state, payload) {
    state.device_data.push(payload.data);
    state.currentIndex = state.device_data.length - 1;
  },

  saveDevice(state, payload) {
    state.device_data[state.currentIndex] = payload.data;
  },

  fetchDevice(state, payload) {
    if (state.currentIndex == -1) {
      state.device_data.push(payload.data);
      state.currentIndex = 0;
    } else {
      state.device_data[state.currentIndex] = payload.data;
    }
  },


  deleteFuelSensor(state,index){
    state.device_data[state.currentIndex].fuel_sensors.splice(index, 1);
  },

  updateCalibration(state, { index, type, elementIndex, value }) {
    // splice (not arr[i] = v) so Vue 2 tracks the array element change
    state.device_data[state.currentIndex].fuel_sensors[index].calibration[type]
      .splice(elementIndex, 1, value);
  },

  addCalibration(state, { index, level, volume }) {
    const sensor = state.device_data[state.currentIndex].fuel_sensors[index];
    sensor.calibration.level.push(level);
    sensor.calibration.volume.push(volume);
  },

  removeCalibration(state, index) {
    const sensor = state.device_data[state.currentIndex].fuel_sensors[index];
    sensor.calibration.level.pop();
    sensor.calibration.volume.pop();
  },

  saveCalibration(state, payload) {
    console.log(state.device_data[state.currentIndex].fuel_sensors[payload.index].calibration)
    state.device_data[state.currentIndex].fuel_sensors[payload.index].calibration = payload.data;
  },

  addFuelSensor(state) {
    state.device_data[state.currentIndex].fuel_sensors.push(
            {
              element_id: 201,
              fuel_sensor_id: state.device_data[state.currentIndex].fuel_sensors.length+1,
              fuel_sensor_type: "Escort TD150",
              capacity: 70,
              sensor_type: "sensorType",
              label: "Primary Tank",
              calibration: {
                level: [
                  0,
                  512,
                  1023
                ],
                volume: [
                  1,
                  50,
                  100
                ]
              },
            }

    )
  },

  checkFuelSensors(state) {
      if(state.device_data[state.currentIndex].fuel_sensors == null) {
        state.device_data[state.currentIndex].fuel_sensors = [];
      }
  },

  deleteDevice(state, payload) {
    state.currentIndex = state.device_data.findIndex(
      device => device.id == payload.data.id
    );
    state.device_data.splice(state.currentIndex, 1);
  },

  enableDevice(state, payload) {
    state.currentIndex = state.device_data.findIndex(
        device => device.id == payload.data.id
    );
    state.device_data[state.currentIndex].active = true;
  },

  disableDevice(state, payload) {
    state.currentIndex = state.device_data.findIndex(
        device => device.id == payload.data.id
    );
    state.device_data[state.currentIndex].active = false;
  },
  reset(state) {
    state.device_data = []
    state.currentIndex = -1
  }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
  async loadAllDevices({ commit }) {
    try {
      commit("loadAllDevices", await Repository.get(`${DEVICE_API}`));
    } catch (error) {
      console.log(error);
    }
  },

  async addDevice({ commit }) {
    await Repository.get(`${DEVICE_API}/new`)
      .then(response => {
        commit("addDevice", response);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async saveDevice({ state, commit }) {
    try {
      commit(
        "saveDevice",
        await Repository.post(
          `${DEVICE_API}`,
          state.device_data[state.currentIndex]
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchDevice({ commit }, payloadID) {
    try {
      commit("fetchDevice", await Repository.get(`${DEVICE_API}/${payloadID}`));
    } catch (error) {
      console.log(error);
    }
  },

  async deleteDevice({ commit }, payloadID) {
    try {
      commit(
        "deleteDevice",
        await Repository.delete(`${DEVICE_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async enableDevice({ commit }, payloadID) {
    try {
      commit(
          "enableDevice",
          await Repository.get(`${DEVICE_API}/enable/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },
  async disableDevice({ commit }, payloadID) {
    try {
      commit(
          "disableDevice",
          await Repository.get(`${DEVICE_API}/disable/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async searchDevices({ commit }, searchTerm) {
    try {
      commit(
        "loadAllDevices",
        await Repository.get(`${DEVICE_API}/search?q=${searchTerm}`)
      );
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
